import styled from "@emotion/styled";
import type { ReactNode } from "react";

import { FONT_WEIGHT_SEMI_BOLD } from "@skilitics/designer-ui-components";

interface Props {
  title?: string;
  operator?: ReactNode;
  value?: ReactNode;
  children?: ReactNode;
  template?: (args: { title?: string; operator?: ReactNode; value?: ReactNode }) => ReactNode;
}

export const ConditionSummaryContainer = styled.div`
  display: contents;
`;

export const Title = styled.span``;

export const SummaryHighlight = styled.span`
  color: ${({ theme }) => theme.secondary};
  font-weight: ${FONT_WEIGHT_SEMI_BOLD};
`;

const OperatorAndValue = styled(SummaryHighlight)`
  margin-left: 4px;
`;

const defaultTemplate = ({ title, operator, value }: { title?: string; operator?: ReactNode; value?: ReactNode }) => (
  <>
    <Title data-test="title">{title}</Title>
    <OperatorAndValue data-test="operator-and-value">
      {operator} {value}
    </OperatorAndValue>
  </>
);

export const ConditionBuilderSummary = ({ title, operator, value, children, template = defaultTemplate }: Props) => {
  return (
    <ConditionSummaryContainer data-test="condition-summary-container">
      {template({ title, operator, value })}
      {children}
    </ConditionSummaryContainer>
  );
};
